import React from "react";
import Header from "../Header/Header";
import MenuDash from "../MenuDash/MenuDash";
import { ToastContainer } from "react-toastify";

const Layout = ({ children, title = "Dashboard" }) => {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ToastContainer />

      <Header title={title} />
      <MenuDash />
      {children}
    </>
  );
};
export default Layout;
